import { useEffect } from "react";
import { Link } from "react-router-dom";
import errorImg from "../../assets/images/banners/404.gif";
import { HandySvg } from "handy-svg";
import iconCross from "../../assets/icons/svg-sprite/close-cross--small.svg";
import iconAttention from "../../assets/icons/svg-sprite/attention.svg";
import closeBanner from "../../modules/close-banner";

const ErrorContent = ({ message }) => {
  useEffect(() => {
    closeBanner();
  }, []);

  return (
    <>
      <section
        className="server-error page__not-found"
        style={{ backgroundColor: "#00a8ff" }}
      >
        <h6 className="visuallyhidden">Ошибка 404</h6>
        <div className="server-error__container page-container">
          <div className="server-error__pic-wrap">
            <div className="server-error__pic-decor"></div>
            <picture className="server-error__picture">
              <img
                className="server-error__img"
                alt="404"
                width="auto"
                height="auto"
                src={errorImg}
              />
            </picture>
          </div>
          <div className="server-error__info-container">
            <span className="server-error__title">Страница не найдена</span>
            <div className="server-error__description">
              <p>
                Пожалуйста, воспользуйтесь навигацией или формой поиска, чтобы
                найти интересующую Вас информацию
              </p>
            </div>
            <div className="server-error__btn-wrap">
              <Link
                className="server-error__btn bttn solid-btn solid-btn--md solid-btn--light-blue"
                to="/"
              >
                На главную
              </Link>
            </div>
          </div>
        </div>
        <div
          id="messageBanner"
          className="info-cards__message-container js-closing-banner is-active"
          style={{ display: "none" }}
        >
          <div className="info-cards__message">
            <div className="info-cards__message-content">
              <HandySvg
                className="svg-icon"
                src={iconAttention}
                width="36"
                height="36"
              />
              <div className="info-cards__message-text">{message}</div>
            </div>
            <button
              className="js-close-btn info-cards__message-btn"
              type="button"
            >
              <HandySvg
                className="svg-icon"
                src={iconCross}
                width="13"
                height="12"
              />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorContent;
